export default __webpack_public_path__ + "img/63664078527dffbf8e89768fa51aaab3.svg";